module.exports = __webpack_public_path__ + "static/netad-aim2-11bfb20cf7011fbe52c07d9a90c8e607.png";